export { default } from './InfluencerTag';
